import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../styles/dashboardTheme.css";
import "../../../../styles/managementTheme.css";
import "../styles/ciclos.css";
import { usePermissions } from "../../../../utils/permissions";
import CoordinacionTabs from "../../catalogo/components/CoordinacionTabs";
import CiclosSummary from "../components/CiclosSummary";
import CiclosFilters from "../components/CiclosFilters";
import CiclosTable from "../components/CiclosTable";
import CiclosFormModal from "../components/CiclosFormModal";

const estadoOptions = [
  { value: "planificado", label: "Planificado" },
  { value: "activo", label: "Activo" },
  { value: "cerrado", label: "Cerrado" },
  { value: "cancelado", label: "Cancelado" },
];

const formatDate = (value) => {
  if (!value) return "-";
  const raw =
    typeof value === "string"
      ? value.split("T")[0]
      : new Date(value).toISOString().split("T")[0];
  const parts = raw.split("-");
  if (parts.length !== 3) return raw || value;
  const [year, month, day] = parts;
  return `${day}/${month}/${year}`;
};

const estadoBadgeClass = (estado = "") => {
  const normalized = estado.toLowerCase();
  if (normalized === "activo") return "bg-success text-white";
  if (normalized === "cerrado") return "bg-secondary text-white";
  if (normalized === "cancelado") return "bg-danger text-white";
  return "bg-info text-dark";
};

const activoBadgeClass = (activo) =>
  activo ? "bg-success-subtle text-success" : "bg-secondary-subtle text-muted";

export default function CiclosView({
  ciclos,
  ciclosPaginados,
  centros,
  loadingCentros,
  centrosError,
  plantillas,
  loadingPlantillas,
  cursos,
  loadingCursos,
  reloadCursos,
  loading,
  listError,
  filtros,
  setFiltros,
  limpiarFiltros,
  lastUpdated,
  page,
  pageSize,
  totalPages,
  total,
  goToPage,
  modal,
  filtro,
  cicloSeleccionado,
  formNuevo,
  setFormNuevo,
  formEditar,
  setFormEditar,
  savingNuevo,
  savingEditar,
  deleting,
  detalleLoading,
  abrirModalNuevo,
  abrirModalEditar,
  abrirModalEliminar,
  cerrarModal,
  reload,
  reloadCentros,
  aniosDisponibles,
  aplicarFiltro,
  stats,
  handleCrearCiclo,
  handleActualizarCiclo,
  handleEliminarCiclo,
}) {
  const { hasPermission } = usePermissions();
  const canCreateCiclo = hasPermission("ciclos.crear");
  const canUpdateCiclo = hasPermission("ciclos.actualizar");
  const canDeleteCiclo = hasPermission("ciclos.eliminar");
  const canManageCiclos = canUpdateCiclo || canDeleteCiclo;

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    if (modal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [modal]);

  const lastSync = lastUpdated ? lastUpdated.toLocaleString() : "Sincronizacion inicial";

  return (
    <section className="management-page management-theme-violet ciclos-wrapper">
      <CoordinacionTabs />
      <div className="management-card management-header mb-4">
        <div>
          <p className="management-eyebrow mb-1">Formacion academica</p>
          <h4 className="management-title mb-1">Ciclos</h4>
          <p className="text-muted mb-0">
            Administra los ciclos base que agrupan convocatorias y promociones.
          </p>
        </div>
        <div className="d-flex flex-column align-items-end gap-2">
          {canCreateCiclo && (
            <button type="button" className="btn management-btn-primary" onClick={abrirModalNuevo}>
              <i className="bi bi-plus-circle me-2" />
              Nuevo ciclo
            </button>
          )}
          <small className="text-muted">Actualizado: {lastSync}</small>
        </div>
      </div>

      <CiclosSummary stats={stats} filtro={filtro} aplicarFiltro={aplicarFiltro} />

      <CiclosFilters
        filtros={filtros}
        setFiltros={setFiltros}
        limpiarFiltros={limpiarFiltros}
        estadoOptions={estadoOptions}
        centros={centros}
        centrosLoading={loadingCentros}
        anioOptions={aniosDisponibles}
      />

      {listError && (
        <div className="alert alert-warning d-flex align-items-center justify-content-between management-alert mb-4">
          <div className="me-3">
            <p className="mb-0">Ciclos: {listError}</p>
          </div>
          <div className="d-flex gap-2 flex-wrap">
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={reload}>
              Reintentar ciclos
            </button>
          </div>
        </div>
      )}

      <CiclosTable
        ciclos={ciclosPaginados ?? ciclos}
        loading={loading}
        listError={listError}
        reload={reload}
        estadoOptions={estadoOptions}
        formatDate={formatDate}
        estadoBadgeClass={estadoBadgeClass}
        activoBadgeClass={activoBadgeClass}
        canManageCiclos={canManageCiclos}
        canUpdateCiclo={canUpdateCiclo}
        canDeleteCiclo={canDeleteCiclo}
        abrirModalEditar={abrirModalEditar}
        abrirModalEliminar={abrirModalEliminar}
      />

      <div className="management-card d-flex justify-content-between align-items-center flex-wrap gap-3">
        <div className="text-muted small">
          Mostrando {total === 0 ? 0 : (page - 1) * pageSize + 1}-{Math.min(total, page * pageSize)} de {total}
        </div>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <div className="btn-group">
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => goToPage(page - 1)}
              disabled={page <= 1}
            >
              <i className="bi bi-chevron-left" />
            </button>
            <button className="btn btn-outline-secondary btn-sm" disabled>
              Pagina {page} / {totalPages}
            </button>
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => goToPage(page + 1)}
              disabled={page >= totalPages}
            >
              <i className="bi bi-chevron-right" />
            </button>
          </div>
        </div>
      </div>

      <CiclosFormModal
        modal={modal}
        cerrarModal={cerrarModal}
        formNuevo={formNuevo}
        setFormNuevo={setFormNuevo}
        formEditar={formEditar}
        setFormEditar={setFormEditar}
        savingNuevo={savingNuevo}
        savingEditar={savingEditar}
        deleting={deleting}
        detalleLoading={detalleLoading}
        cicloSeleccionado={cicloSeleccionado}
        centros={centros}
        centrosLoading={loadingCentros}
        centrosError={centrosError}
        reloadCentros={reloadCentros}
        plantillas={plantillas}
        loadingPlantillas={loadingPlantillas}
        cursos={cursos}
        loadingCursos={loadingCursos}
        reloadCursos={reloadCursos}
        estadoOptions={estadoOptions}
        handleCrearCiclo={handleCrearCiclo}
        handleActualizarCiclo={handleActualizarCiclo}
        handleEliminarCiclo={handleEliminarCiclo}
        canCreate={canCreateCiclo}
        canUpdate={canUpdateCiclo}
        canDelete={canDeleteCiclo}
      />
    </section>
  );
}
